import complexes from './complexes'
import sections from './sections'
import layouts from './layouts'
import objects from './objects'
import floors from './floors'
import management_comp from './management_comp'
import advantages from './advantages'
import bti_plans from './bti_plans'

export default {
  objects: {
    namespaced: true,
    modules: {
      complexes,
      sections,
      objects,
      layouts,
      floors,
      management_comp,
      advantages,
      bti_plans

    }
  }
}
